import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {EntitiesRecognizerResponseApiModel} from "../models/entities-recognizer.response-api-model";
import {EntitiesRecognizerDataSource} from "../models/entities-recognizer.data-source";

export class EntitiesRecognizerFactory extends BaseFactory {
  static injectables = [...BaseFactory.injectables];

  createResponse(response: EntitiesRecognizerResponseApiModel) {
    const responseApiModel: EntitiesRecognizerResponseApiModel = new EntitiesRecognizerResponseApiModel(response);

    return responseApiModel;
  }

  createDomainModel(apiModel: EntitiesRecognizerResponseApiModel) {
    const domainModel: EntitiesRecognizerDataSource = new EntitiesRecognizerDataSource(apiModel);

    return domainModel;
  }
}

